<template>
  <b-container class="col-12">
    <ValidationObserver ref="observer3">
      <b-row>
        <b-col class="col-12">
          <b>
            <label>Coverage Information</label>
          </b>
          <br />
          <span>Please take out your red, white and blue Medicare card to complete this section.</span>
          <ul>
            <li>Fill out this information as it appears on your Medicare card.</li>
            <li>You must have Medicare Part A and Part B to join a Medicare Advantage plan.</li>
          </ul>
          <span class="add-info">
            <b>
              All lines marked with an asterisk (
              <font color="red">*</font>) are required.
            </b>
          </span>
          <hr />
          <b-form-group
            label-cols-sm="4"
            label="Name (as it appears on your Medicare card)"
            label-for="medicardfullname"
            label-class="font-weight-bold pt-0"
            class="mb-2"
          >
            <b-form-input
              id="medicardfullname"
              placeholder="Name"
              class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
              v-model="form.medicardfullname"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            label-cols-sm="4"
            label="Medicare Number "
            label-for="mediBeniIendtifier"
            label-class="font-weight-bold pt-0 custom-req"
            class="mb-2"
          >
            <validation-provider
              rules="required|mbiLength|mbiPattern"
              :bails="false"
              v-slot="{ classes, errors }"
              name="Medicare Number "
              class="col-3 p-0 mr-1"
              vid="mediBeniIendtifier"
            >
              <div class="control" :class="classes">
                <b-form-input
                  id="mediBeniIendtifier"
                  required
                  class="col-xs-8 col-sm-8 col-md-8 col-lg-6"
                  ref="mediBeniIendtifier"
                  maxlength="11"
                  placeholder="Medicare Number"
                  v-model="form.mediBeniIendtifier"
                ></b-form-input>
                <span>{{errors[0]}}</span>
              </div>
            </validation-provider>
          </b-form-group>
<!--          <b-form-group-->
<!--            label-cols-sm="3"-->
<!--            label="Is Entitled To"-->
<!--            label-for="entitledto"-->
<!--            label-class="font-weight-bold pt-0"-->
<!--            class="mb-2"-->
<!--            style="margin-top:-20px"-->
<!--          >-->
<!--            <b-form-input id="entitledto" required class="col-xs-8 col-sm-8 col-md-8 col-lg-6" v-model="form.entitledto"></b-form-input>-->
<!--          </b-form-group>-->
        </b-col>
      </b-row>
    </ValidationObserver>
  </b-container>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import "vue-themify-icons/themify-icons/themify-icons.css";

export default {
  name: "CoverageInfo",
  components: {},
  data() {
    return {};
  },
  props: {
    form: Object
  }
};
</script>
